import { lookupService } from '../../helpers/services/lookup.service';
import i18n from '@/i18n'
import { sharedHelper } from '@/utils'

export const state = {
  roleDdl: [],
  permissionDdl: [],
  userDdl: [],
  companyDdl: [],
  departmentDdl: [],
  formDdl: [],
  classDdl: [],
  moaDdl: [],
  typeDdl: [],
  purposeDdl: [],
  brandDdl: [],
  statusDdl: [],
  productDdl: [],
  aiDdl: [],

  groupDdl: [],
  locationDdl: [],
  propertyTypeDdl: [],
  propertyTenureDdl: [],
  propertyCategoryDdl: [],
  propertyStatusDdl: [],
  propertyActionDdl: [],
  amenityDdl: [],
  meetingRoomDdl: [],
  jobDdl: [],
  sourceDdl: [],
};

export const LOOKUP_MODULE = "lookup";

// define action 
export const LOOKUP_ROLE = 'lookupRole';
export const LOOKUP_PERMISSION = 'lookupPermission';
export const LOOKUP_COMPANY = 'lookupCompany';
export const LOOKUP_JOB = 'lookupJob';
export const LOOKUP_DEPARTMENT = 'lookupDepartment';
export const LOOKUP_FORM = 'lookupForm';
export const LOOKUP_CLASS = 'lookupClass';
export const LOOKUP_MOA = 'lookupMOA';
export const LOOKUP_TYPE = 'lookupType';
export const LOOKUP_PURPOSE = 'lookupPurpose';
export const LOOKUP_BRAND = 'lookupBrand';
export const LOOKUP_STATUS = 'lookupStatus';
export const LOOKUP_USER = 'lookupUser';
export const LOOKUP_PRODUCTS = 'lookupProduct';
export const LOOKUP_AIS = 'lookupAI';
export const LOOKUP_PRODUCT_CREATE_UPDATES = 'lookupProductgetLookupProductCreateUpdates';
export const LOOKUP_GROUP = 'lookupGroup';
export const LOOKUP_LOCATION = 'lookupLocation';
export const LOOKUP_PROPERTY_TYPE = 'lookupPropertyType';
export const LOOKUP_PROPERTY_TENURE = 'lookupPropertyTenure';
export const LOOKUP_PROPERTY_CATEGORY = 'lookupPropertyCategory';
export const LOOKUP_PROPERTY_STATUS = 'lookupPropertyStatus';
export const LOOKUP_PROPERTY_ACTION = 'lookupPropertyAction';
export const LOOKUP_AMENITY = 'lookupAmenity';
export const LOOKUP_MEETING_ROOM = 'lookupMeetingRoom';
export const LOOKUP_SOURCE = 'lookupSource';

// define mutation
const ROLE_LOOKUP = "roleLookup";
const PERMISSION_LOOKUP = "permissionLookup";
const USER_LOOKUP = "userLookup";
const COMPANY_LOOKUP = "companyLookup";
const JOB_LOOKUP = "jobLookup";
const DEPARTMENT_LOOKUP = "departmentLookup";
const FORM_LOOKUP = "formLookup";
const CLASS_LOOKUP = "classLookup";
const MOA_LOOKUP = "moaLookup";
const TYPE_LOOKUP = "typeLookup";
const PURPOSE_LOOKUP = "purposeLookup";
const BRAND_LOOKUP = "brandLookup";
const STATUS_LOOKUP = "statusLookup";
const PRODUCT_LOOKUP = "productLookup";
const AI_LOOKUP = "AILookup";
const SOURCE_LOOKUP = "sourceLookup";
const PRODUCT_CREATE_UPDATE_LOOKUP = "productCreateUpdateLookup";
const GROUP_LOOKUP = "groupLookup";
const LOCATION_LOOKUP = "locationLookup";
const PROPERTY_TYPE_LOOKUP = "propertyTypeLookup";
const PROPERTY_TENURE_LOOKUP = "propertyTenureLookup";
const PROPERTY_CATEGORY_LOOKUP = "propertyCategoryLookup";
const PROPERTY_STATUS_LOOKUP = "propertyStatusLookup";
const PROPERTY_ACTION_LOOKUP = "propertyActionLookup";
const AMENITY_LOOKUP = "amenityLookup";
const MEETING_ROOM_LOOKUP = "meetingRoomLookup";

export const mutations = {

  [SOURCE_LOOKUP](state, { data }) {
    let p = []
    let response = data

    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.uuid,
          text: x.name
        })
      })

      state.sourceDdl = p
    } else {
      state.sourceDdl = []
    }
  },

  [PRODUCT_LOOKUP](state, { data }) {
    let p = []
    let response = data

    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.uuid,
          text: x.name
        })
      })

      state.productDdl = p
    } else {
      state.productDdl = []
    }
  },

  [AI_LOOKUP](state, { data }) {
    let p = []
    let response = data

    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.uuid,
          text: x.name
        })
      })

      state.aiDdl = p
    } else {
      state.aiDdl = []
    }
  },

  [ROLE_LOOKUP](state, { data }) {
    let p = []
    let response = data

    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.value,
          text: x.name
        })
      })

      state.roleDdl = p
    } else {
      state.roleDdl = []
    }
  },

  [USER_LOOKUP](state, { data }) {
    let p = []
    let response = data

    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.value,
          text: x.name
        })
      })

      state.userDdl = p
    } else {
      state.userDdl = []
    }
  },

  [COMPANY_LOOKUP](state, { data }) {
    let p = []
    let response = data

    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.uuid,
          text: x.name
        })
      })

      state.companyDdl = p
    } else {
      state.companyDdl = []
    }
  },

  [JOB_LOOKUP](state, { data }) {
    let p = []
    let response = data

    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.uuid,
          text: x.name
        })
      })

      state.jobDdl = p
    } else {
      state.jobDdl = []
    }
  },

  [DEPARTMENT_LOOKUP](state, { data }) {
    let p = []
    let response = data

    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.uuid,
          text: x.name
        })
      })

      state.departmentDdl = p
    } else {
      state.departmentDdl = []
    }
  },

  [GROUP_LOOKUP](state, { data }) {
    let p = []
    let response = data

    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.uuid,
          text: x.name,
          photoUrl: x?.photo_url,
        })
      })

      state.groupDdl = p
    } else {
      state.groupDdl = []
    }
  },

  [LOCATION_LOOKUP](state, { data }) {
    let p = []
    let response = data

    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.uuid,
          text: x.name,
        })
      })

      state.locationDdl = p
    } else {
      state.locationDdl = []
    }
  },

  [MEETING_ROOM_LOOKUP](state, { data }) {
    let p = []
    let response = data

    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.uuid,
          text: x.name,
        })
      })

      state.meetingRoomDdl = p
    } else {
      state.meetingRoomDdl = []
    }
  },

  [AMENITY_LOOKUP](state, { data }) {
    let p = []
    let response = data

    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.uuid,
          text: x.name,
        })
      })

      state.amenityDdl = p
    } else {
      state.amenityDdl = []
    }
  },

  [PROPERTY_TYPE_LOOKUP](state, { data }) {
    let p = []
    let response = data
    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.value,
          text: x.name
        })
      })

      state.propertyTypeDdl = p
    } else {
      state.propertyTypeDdl = []
    }
  },

  [PROPERTY_TENURE_LOOKUP](state, { data }) {
    let p = []
    let response = data
    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.value,
          text: x.name
        })
      })

      state.propertyTenureDdl = p
    } else {
      state.propertyTenureDdl = []
    }
  },

  [PROPERTY_CATEGORY_LOOKUP](state, { data }) {
    let p = []
    let response = data
    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.value,
          text: x.name
        })
      })

      state.propertyCategoryDdl = p
    } else {
      state.propertyCategoryDdl = []
    }
  },

  [PROPERTY_STATUS_LOOKUP](state, { data }) {
    let p = []
    let response = data
    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.value,
          text: x.name
        })
      })

      state.propertyStatusDdl = p
    } else {
      state.propertyStatusDdl = []
    }
  },

  [PROPERTY_ACTION_LOOKUP](state, { data }) {
    let p = []
    let response = data
    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.value,
          text: x.name
        })
      })

      state.propertyActionDdl = p
    } else {
      state.propertyActionDdl = []
    }
  },

  [FORM_LOOKUP](state, { data }) {
    let p = []
    let response = data

    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.uuid,
          text: x.name
        })
      })

      state.formDdl = p
    } else {
      state.formDdl = []
    }
  },


  [CLASS_LOOKUP](state, { data }) {
    let p = []
    let response = data

    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.uuid,
          text: x.name
        })
      })

      state.classDdl = p
    } else {
      state.classDdl = []
    }
  },

  [MOA_LOOKUP](state, { data }) {
    let p = []
    let response = data

    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.uuid,
          text: x.name
        })
      })

      state.moaDdl = p
    } else {
      state.moaDdl = []
    }
  },


  [TYPE_LOOKUP](state, { data }) {
    let p = []
    let response = data

    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.uuid,
          text: x.name
        })
      })

      state.typeDdl = p
    } else {
      state.typeDdl = []
    }
  },


  [PURPOSE_LOOKUP](state, { data }) {
    let p = []
    let response = data

    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.uuid,
          text: x.name
        })
      })

      state.purposeDdl = p
    } else {
      state.purposeDdl = []
    }
  },


  [BRAND_LOOKUP](state, { data }) {
    let p = []
    let response = data

    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.uuid,
          text: x.name
        })
      })

      state.brandDdl = p
    } else {
      state.brandDdl = []
    }
  },


  // eslint-disable-next-line no-unused-vars
  [PERMISSION_LOOKUP](state, { data, hasOptionAll }) {

    function getCodeAndLabelFromPermission(permission) {
      return {
        code: permission.code,
        label: permission.name,
      }
    }

    state.permissionDdl = data.data.map((permissionModule) => {
      return {
        module: permissionModule.module,
        submodule: permissionModule.submodule,
        permissions: permissionModule.permissions.map(getCodeAndLabelFromPermission)
      }
    })
  },

  // eslint-disable-next-line no-unused-vars
  [STATUS_LOOKUP](state, { data, hasOptionAll }) {

    let p = []
    let response = data

    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.uuid,
          text: x.name
        })
      })

      state.statusDdl = p
    } else {
      state.statusDdl = []
    }
  },

  modulePermissionLookup(state, { data }) {
    function getCodeAndLabelFromPermission(permission) {
      return {
        code: permission.code,
        label: i18n.t(`permissions.${permission.code}`)
      }
    }

    state.permissionDdl = data.data.map((permissionModule) => {
      return {
        module: permissionModule.module,
        submodule: permissionModule.submodule,
        permissions: permissionModule.permissions.map(getCodeAndLabelFromPermission)
      }
    })
  },

  [PRODUCT_CREATE_UPDATE_LOOKUP](state, { data }) {
    let brands = []
    let classes = []
    let companies = []
    let departments = []
    let forms = []
    let moas = []
    let purposes = []
    let types = []
    let statuses = []
    let response = data

    if (response.success) {
      response.data.brands.forEach((x) => {
        brands.push({
          value: x.uuid,
          text: x.name
        })
      })

      response.data.classes.forEach((x) => {
        classes.push({
          value: x.uuid,
          text: x.name
        })
      })

      response.data.companies.forEach((x) => {
        companies.push({
          value: x.uuid,
          text: x.name
        })
      })

      response.data.departments.forEach((x) => {
        companies.push({
          value: x.uuid,
          text: x.name
        })
      })

      response.data.forms.forEach((x) => {
        forms.push({
          value: x.uuid,
          text: x.name
        })
      })

      response.data.moas.forEach((x) => {
        moas.push({
          value: x.uuid,
          text: x.name
        })
      })

      response.data.purposes.forEach((x) => {
        purposes.push({
          value: x.uuid,
          text: x.name
        })
      })

      response.data.types.forEach((x) => {
        types.push({
          value: x.uuid,
          text: x.name
        })
      })

      response.data.status.forEach((x) => {
        statuses.push({
          value: x.uuid,
          text: x.name
        })
      })

      state.brandDdl = brands
      state.classDdl = classes
      state.companyDdl = companies
      state.departmentDdl = departments
      state.formDdl = forms
      state.moaDdl = moas
      state.purposeDdl = purposes
      state.typeDdl = types
      state.statusDdl = statuses

    } else {
      state.brandDdl = []
      state.classDdl = []
      state.companyDdl = []
      state.departmentDdl = []
      state.formDdl = []
      state.moaDdl = []
      state.purposeDdl = []
      state.typeDdl = []
      state.statusDdl = []
    }
  },


};

export const actions = {

  [LOOKUP_ROLE]({ commit }, { hasOptionAll }) {
    lookupService.getLookupRoles().then(
      (data) => {
        commit(ROLE_LOOKUP, { data })
      },
      (error) => {
        let message = 'Role Lookup' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(ROLE_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  [LOOKUP_SOURCE]({ commit }, { hasOptionAll }) {
    lookupService.getLookupSource().then(
      (data) => {
        commit(SOURCE_LOOKUP, { data })
      },
      (error) => {
        let message = 'Source Lookup' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(SOURCE_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  [LOOKUP_COMPANY]({ commit }, { hasOptionAll }) {
    lookupService.getLookupCompanies().then(
      (data) => {
        commit(COMPANY_LOOKUP, { data })
      },
      (error) => {
        let message = 'Company Lookup ' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(COMPANY_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  [LOOKUP_JOB]({ commit }, { hasOptionAll }) {
    lookupService.getLookupJobs().then(
      (data) => {
        commit(JOB_LOOKUP, { data })
      },
      (error) => {
        let message = 'Job Lookup ' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(JOB_LOOKUP, { error, hasOptionAll })
      }
    )
  },


  [LOOKUP_DEPARTMENT]({ commit }, { hasOptionAll, companyID }) {
    lookupService.getLookupDepartments(companyID).then(
      (data) => {
        commit(DEPARTMENT_LOOKUP, { data })
      },
      (error) => {
        let message = 'Department Lookup ' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(DEPARTMENT_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  [LOOKUP_GROUP]({ commit }, { hasOptionAll }) {
    lookupService.getLookupGroup().then(
      (data) => {
        commit(GROUP_LOOKUP, { data })
      },
      (error) => {
        let message = 'Group Lookup ' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(GROUP_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  [LOOKUP_LOCATION]({ commit }, { hasOptionAll }) {
    lookupService.getLookupLocation().then(
      (data) => {
        commit(LOCATION_LOOKUP, { data })
      },
      (error) => {
        let message = 'Location Lookup ' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(LOCATION_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  [LOOKUP_MEETING_ROOM]({ commit }, { hasOptionAll }) {
    lookupService.getMeetingRoom().then(
      (data) => {
        commit(MEETING_ROOM_LOOKUP, { data })
      },
      (error) => {
        let message = 'Meeting Room Lookup ' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(MEETING_ROOM_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  [LOOKUP_AMENITY]({ commit }, { hasOptionAll }) {
    lookupService.getLookupAmenity().then(
      (data) => {
        commit(AMENITY_LOOKUP, { data })
      },
      (error) => {
        let message = 'Amenity Lookup ' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(AMENITY_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  [LOOKUP_PROPERTY_TYPE]({ commit }, { hasOptionAll }) {
    lookupService.getLookupPropertyType().then(
      (data) => {
        commit(PROPERTY_TYPE_LOOKUP, { data })
      },
      (error) => {
        let message = 'Property Type Lookup ' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(PROPERTY_TYPE_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  [LOOKUP_PROPERTY_TENURE]({ commit }, { hasOptionAll }) {
    lookupService.getLookupPropertyTenure().then(
      (data) => {
        commit(PROPERTY_TENURE_LOOKUP, { data })
      },
      (error) => {
        let message = 'Property Tenure Lookup ' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(PROPERTY_TENURE_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  [LOOKUP_PROPERTY_CATEGORY]({ commit }, { hasOptionAll }) {
    lookupService.getLookupPropertyCategory().then(
      (data) => {
        commit(PROPERTY_CATEGORY_LOOKUP, { data })
      },
      (error) => {
        let message = 'Property Category Lookup ' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(PROPERTY_CATEGORY_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  [LOOKUP_PROPERTY_STATUS]({ commit }, { hasOptionAll }) {
    lookupService.getLookupPropertyStatus().then(
      (data) => {
        commit(PROPERTY_STATUS_LOOKUP, { data })
      },
      (error) => {
        let message = 'Property Status Lookup ' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(PROPERTY_STATUS_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  [LOOKUP_PROPERTY_ACTION]({ commit }, { hasOptionAll }) {
    lookupService.getLookupPropertyAction().then(
      (data) => {
        commit(PROPERTY_ACTION_LOOKUP, { data })
      },
      (error) => {
        let message = 'Property Action Lookup ' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(PROPERTY_ACTION_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  [LOOKUP_PERMISSION]({ commit }, { hasOptionAll }) {
    lookupService.getAllModulePermissions().then(
      (data) => {
        commit(PERMISSION_LOOKUP, { data, hasOptionAll })
      },
      (error) => {
        let message = 'Permission Lookup' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(PERMISSION_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  [LOOKUP_FORM]({ commit }, { hasOptionAll }) {
    lookupService.getLookupForms().then(
      (data) => {
        commit(FORM_LOOKUP, { data, hasOptionAll })
      },
      (error) => {
        let message = 'Form Lookup ' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(FORM_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  [LOOKUP_USER]({ commit }, { hasOptionAll }) {
    lookupService.getLookupUsers().then(
      (data) => {
        commit(USER_LOOKUP, { data })
      },
      (error) => {
        let message = 'User Lookup' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(USER_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  [LOOKUP_CLASS]({ commit }, { hasOptionAll }) {
    lookupService.getLookupClasses().then(
      (data) => {
        commit(CLASS_LOOKUP, { data })
      },
      (error) => {
        let message = 'Class Lookup' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(CLASS_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  [LOOKUP_MOA]({ commit }, { hasOptionAll }) {
    lookupService.getLookupMoas().then(
      (data) => {
        commit(MOA_LOOKUP, { data })
      },
      (error) => {
        let message = 'MOA Lookup ' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(MOA_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  [LOOKUP_TYPE]({ commit }, { hasOptionAll }) {
    lookupService.getLookupTypes().then(
      (data) => {
        commit(TYPE_LOOKUP, { data })
      },
      (error) => {
        let message = 'Type Lookup ' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(TYPE_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  [LOOKUP_PURPOSE]({ commit }, { hasOptionAll }) {
    lookupService.getLookupPurposes().then(
      (data) => {
        commit(PURPOSE_LOOKUP, { data })
      },
      (error) => {
        let message = 'Purpose Lookup ' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(PURPOSE_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  async [LOOKUP_BRAND]({ commit }, { hasOptionAll }) {
    await lookupService.getLookupBrands().then(
      (data) => {
        commit(BRAND_LOOKUP, { data })
      },
      (error) => {
        let message = 'Brand Lookup ' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(BRAND_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  [LOOKUP_STATUS]({ commit }, { hasOptionAll }) {
    lookupService.getLookupStatus().then(
      (data) => {
        commit(STATUS_LOOKUP, { data })
      },
      (error) => {
        let message = 'Status Lookup ' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(STATUS_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  async [LOOKUP_PRODUCTS]({ commit }, { hasOptionAll }) {
    await lookupService.getLookupProducts().then(
      (data) => {
        commit(PRODUCT_LOOKUP, { data })
      },
      (error) => {
        let message = 'product Lookup ' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(PRODUCT_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  [LOOKUP_AIS]({ commit }, { hasOptionAll }) {
    lookupService.getLookupAIs().then(
      (data) => {
        commit(AI_LOOKUP, { data })
      },
      (error) => {
        let message = 'AI Lookup ' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(AI_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  [LOOKUP_PRODUCT_CREATE_UPDATES]({ commit }, { hasOptionAll }) {
    lookupService.getLookupProductCreateUpdates().then(
      (data) => {
        commit(PRODUCT_CREATE_UPDATE_LOOKUP, { data })
      },
      (error) => {
        let message = 'Product Lookup ' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(PRODUCT_CREATE_UPDATE_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  // eslint-disable-next-line no-unused-vars
  getPermissionModuleLookup({ commit, dispatch }, { hasOptionAll }) {
    lookupService.getAllModulePermissions().then(
      (data) => {
        commit('modulePermissionLookup', { data, hasOptionAll })
      },
      (error) => {
        commit('modulePermissionLookup', { error, hasOptionAll })
      }
    )
  },
};
